let load = require('./helpers/browser/esm-js-loader-shards')(4);
module.exports = (load("bjkD0")).then(() => parcelRequire('bVK4x'));